// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-AuthChecker-overlays-LoginPage-LoginPage-module__btn--Vf_OR {
  width: 100%;
}
/*# sourceMappingURL=LoginPage.module.css.map */`, "",{"version":3,"sources":["webpack://./LoginPage.module.less","webpack://./src/components/AuthChecker/overlays/LoginPage/LoginPage.module.less"],"names":[],"mappings":"AAAA;EACE,WAAA;ACCF;AACA,+CAA+C","sourcesContent":[".btn {\n  width: 100%;\n}\n",".btn {\n  width: 100%;\n}\n/*# sourceMappingURL=LoginPage.module.css.map */"],"sourceRoot":""}]);
// Exports
export var btn = `src-components-AuthChecker-overlays-LoginPage-LoginPage-module__btn--Vf_OR`;
export default ___CSS_LOADER_EXPORT___;
